import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2786929c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-bar" }
const _hoisted_2 = { style: {"margin":"24px 0 16px","display":"flex","align-items":"center"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "oio-group-title" }, "订单商品明细", -1))
const _hoisted_4 = { style: {"margin-left":"auto","display":"flex","align-items":"center"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "订单编码：", -1))
const _hoisted_6 = { style: {"margin-left":"30px","display":"flex","align-items":"center"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "买家名称：", -1))
const _hoisted_8 = { style: {"height":"500px","flex":"auto"} }
const _hoisted_9 = { id: "PACA-PROMOTION-CELL" }
const _hoisted_10 = { style: {"height":"50px","line-height":"50px"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "将", -1))
const _hoisted_12 = { style: {"width":"300px"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "修改为", -1))
const _hoisted_14 = { style: {"width":"300px"} }
const _hoisted_15 = { class: "operation-col" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "若计划备货未完成情况下，请与调拨处理人沟通取消数量", -1))

import { ref, computed, watch,onMounted } from 'vue';
import {OioButton, OioCol, OioForm, OioFormItem, OioInput, OioModal, OioRow} from '@kunlun/vue-ui-antd';
import {
  FullscreenExitOutlined,
  FullscreenOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined
} from '@ant-design/icons-vue';
import { cloneDeep } from 'lodash-es';
import { useFullscreen } from '../../../../hooks/fullscreen';
import { useProductPackage } from "../../../../hooks";
interface IProps {
  formData: any;
  _data: any;
  viewCreateOrderSaleSkuList: any[];
  mountedProcessSignal: boolean;
  itemCheckedStatusArr: boolean[] | [];
}


const __default__ = {
  name: 'PartialCancellation'
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    formData: null,
    _data: null,
    viewCreateOrderSaleSkuList: null,
    mountedProcessSignal: { type: Boolean },
    itemCheckedStatusArr: null
  },
  setup(__props: any) {

const props = __props as { formData: any, _data: any, viewCreateOrderSaleSkuList: any[], mountedProcessSignal: boolean, itemCheckedStatusArr: boolean[] | [] }

const { generateConvertRelationStr } = useProductPackage();



const tableRef = ref<any>();
const customerDemandCancelVisible = ref(false);
const customerDemandCancelFormRef = ref<InstanceType<typeof OioForm>>();
const searchVal = ref('');

const currentItemCheckedStatusArr = ref<boolean[] | []>([]);
const checkAllStatus = ref(true); //全选
const changeAllCheckedStatus = () => {
  currentItemCheckedStatusArr.value = Array(currentItemCheckedStatusArr.value.length).fill(checkAllStatus.value);
};
const changeItemCheckedStatus = () => {
  let unCheckedLength = currentItemCheckedStatusArr.value.filter((item) => item === false)?.length;
  if (unCheckedLength > 0) {
    checkAllStatus.value = false;
  } else {
    checkAllStatus.value = true;
  }
};
// 半选状态
const indeterminateStatus = computed(() => {
  let unCheckedLength = currentItemCheckedStatusArr.value.filter((item) => item === false)?.length;
  if (unCheckedLength > 0 && unCheckedLength < currentItemCheckedStatusArr.value.length) {
    return true;
  } else {
    return false;
  }
});

const displayDataList = computed(() => {
  const keyList = searchVal.value.split(/[ \t\n]/).filter((s) => s);
  return (
    props.viewCreateOrderSaleSkuList?.filter((item) => {
      if (keyList.length === 0) {
        return true;
      }
      return keyList.some((key) =>
        ((item.itemCode ?? '') + (item.itemName ?? '') + (item.outCode ?? ''))?.includes?.(key)
      );
    }) ?? []
  );
});

onMounted(()=>{
  console.log(props.formData);
  customerDemandCancelVisible.value = props.formData.transferOrder != undefined;
})

const checkedTotal = computed(() => {
  return currentItemCheckedStatusArr.value
    .map((value, index) => (value ? index : null))
    .filter((index) => index !== null).length;
});
const createdSubmitData = () => {
  let trueIndices: any[] = [];
  if (displayDataList.value.length === props.viewCreateOrderSaleSkuList.length) {
    //未进行筛选
    trueIndices = currentItemCheckedStatusArr.value
      .map((value, index) => (value ? index : null))
      .filter((index) => index !== null);
  } else {
    //进行了筛选
    // indices
    let currentIndexArr = currentItemCheckedStatusArr.value
      .map((value, index) => (value ? index : null))
      .filter((index) => index !== null);
    let currentItemArr = displayDataList.value.map((item) => item.tradeOrderDetailId);
    let itemcodeCheckedArr = currentIndexArr.map((item) => currentItemArr[item]);
    itemcodeCheckedArr.forEach((tradeOrderDetailId) => {
      const index = props.viewCreateOrderSaleSkuList.findIndex((item) => item.tradeOrderDetailId === tradeOrderDetailId);
      if (index !== -1) {
        trueIndices.push(index);
      }
    });
  }
  props.formData.createOrderSaleSkuList = trueIndices.map((item) => props.viewCreateOrderSaleSkuList[item]);
};
// 初始化时
watch(
  () => props.itemCheckedStatusArr,
  () => {
    checkAllStatus.value = true;
    currentItemCheckedStatusArr.value = props.itemCheckedStatusArr;
  }
);

watch(
    () => props.formData,
    () => {
      customerDemandCancelVisible.value = props.formData.transferOrder != undefined;
    }
);

//选中的数量发生变化的时候
watch(
  () => checkedTotal.value,
  () => {
    createdSubmitData();
  }
);
let openPlanDetail = false;
// 创建一个存储下标的对象
const indices = {};
watch(
  () => displayDataList.value,
  () => {
    if (openPlanDetail && displayDataList.value.length) {
      checkAllStatus.value = true;
      currentItemCheckedStatusArr.value = Array(displayDataList.value.length).fill(checkAllStatus.value);
      if (displayDataList.value.length != props.viewCreateOrderSaleSkuList.length) {
        const tradeOrderDetailIds = displayDataList.value.map((item) => item.tradeOrderDetailId);
        // 遍历ids数组，查找每个ID在data数组中的下标
        tradeOrderDetailIds.forEach((tradeOrderDetailId) => {
          const index = props.viewCreateOrderSaleSkuList.findIndex((item) => item.tradeOrderDetailId === tradeOrderDetailId);
          if (index !== -1) {
            indices[tradeOrderDetailId] = index;
          } else {
            indices[tradeOrderDetailId] = null; // 表示未找到
          }
        });
      }
      props.formData.createOrderSaleSkuList = displayDataList.value;
    }
    openPlanDetail = true;
  }
);

const getPopupContainer = (triggerNode: HTMLElement) => {
  let curNode = triggerNode;
  while (curNode) {
    if (curNode.id === 'PACA-content' || curNode.id === 'PACA-PROMOTION-CELL') {
      return curNode;
    }
    curNode = curNode.parentNode as HTMLElement;
  }
  return document.body;
};

const handleReasonChange = (scope, id) => {
  const reasonObj = props._data.cancelReasonList.find((item) => id && item.id === id);
  scope.row.deliAriesSellerOrderCancelReason = reasonObj ?? null;
  props.formData.createOrderSaleSkuList.forEach((item) => {
    if (item.tradeOrderDetailId === scope.row.tradeOrderDetailId) {
      item.deliAriesSellerOrderCancelReason = reasonObj ?? null;
    }
  });
  createdSubmitData();
};

const contentRef = ref<HTMLElement | undefined>();
const { isFullscreen, toggleFullscreen } = useFullscreen(contentRef);

const editModalVisible = ref(false);
const originalEditTypeOptions: {
  label: string;
  value: string;
}[] = [
  { label: '取消数量', value: 'applyCloseNum' },
  { label: '取消原因', value: 'deliAriesSellerOrderCancelReason' }
];
const displayEditTypeOptions = computed(() => {
  type Writeable<T> = { -readonly [P in keyof T]: T[P] };
  const copy: any[] = cloneDeep(originalEditTypeOptions as Writeable<typeof originalEditTypeOptions>);
  copy.forEach((item) => {
    item.disabled = editModalDataList.value.some((data) => data.type === item.value);
  });
  return copy;
});
const editModalDataList = ref<{ type?: typeof originalEditTypeOptions[number]['value']; value?: any; id: number }[]>([
  { id: 0 }
]);
const applyBatchEdit = () => {
  let trueIndices: any[] = [];
  if (displayDataList.value.length === props.viewCreateOrderSaleSkuList.length) {
    //未进行筛选
    trueIndices = currentItemCheckedStatusArr.value
      .map((value, index) => (value ? index : null))
      .filter((index) => index !== null);
  } else {
    //进行了筛选
    // indices

    let currentIndexArr = currentItemCheckedStatusArr.value
      .map((value, index) => (value ? index : null))
      .filter((index) => index !== null);
    let currentItemArr = displayDataList.value.map((item) => item.tradeOrderDetailId);
    let itemcodeCheckedArr = currentIndexArr.map((item) => currentItemArr[item]);
    itemcodeCheckedArr.forEach((tradeOrderDetailId) => {
      const index = props.viewCreateOrderSaleSkuList.findIndex((item) => item.tradeOrderDetailId === tradeOrderDetailId);
      if (index !== -1) {
        trueIndices.push(index);
      }
    });
  }
  for (const { type, value } of editModalDataList.value) {
    if (!type) {
      continue;
    }
    for (const item of trueIndices) {
      let _value = value;
      if (type === 'deliAriesSellerOrderCancelReason') {
        _value = props._data.cancelReasonList.find((it) => value && it.id === value) ?? null;
      }
      props.viewCreateOrderSaleSkuList[item][type] = _value;
    }
  }
  props.formData.createOrderSaleSkuList = trueIndices.map((item) => props.viewCreateOrderSaleSkuList[item]);
};
const onSubmitBatchEdit = async () => {
  applyBatchEdit();
  editModalDataList.value = [{ id: count++ }];
  editModalVisible.value = false;
};
const getModalContainer = () => {
  const container = document.getElementById('PACA-content');
  return container ?? document.body;
};
let count = 1;
const addEditModalRow = () => {
  editModalDataList.value.push({
    id: count++
  });
};
const removeEditModalRow = (id: number) => {
  editModalDataList.value = editModalDataList.value.filter((item) => item.id !== id);
};

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_vxe_table = _resolveComponent("vxe-table")!

  return (_openBlock(), _createElementBlock("div", {
    class: "content",
    id: "PACA-content",
    ref_key: "contentRef",
    ref: contentRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(OioButton), {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (editModalVisible.value = true))
      }, {
        default: _withCtx(() => [
          _createTextVNode("批量修改")
        ]),
        _: 1
      }),
      _createVNode(_unref(OioInput), {
        value: searchVal.value,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchVal).value = $event)),
        placeholder: "按货号、商品名称、物料号搜索",
        style: {"width":"340px","margin-left":"auto"},
        "allow-clear": ""
      }, null, 8, ["value"]),
      _createElementVNode("span", {
        style: {"font-size":"20px","margin-left":"10px","cursor":"pointer"},
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(toggleFullscreen) && _unref(toggleFullscreen)(...args)))
      }, [
        (!_unref(isFullscreen))
          ? (_openBlock(), _createBlock(_unref(FullscreenOutlined), { key: 0 }))
          : (_openBlock(), _createBlock(_unref(FullscreenExitOutlined), { key: 1 }))
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", null, _toDisplayString(__props.formData.orderCode), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", null, _toDisplayString(__props.formData.buyerName), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_vxe_table, {
        "header-align": "center",
        border: "",
        ref_key: "tableRef",
        ref: tableRef,
        height: "auto",
        "keep-source": "",
        "column-config": { resizable: true },
        data: _unref(displayDataList),
        "edit-config": { trigger: 'click', mode: 'cell' },
        "scroll-x": { enabled: false },
        "scroll-y": { enabled: true, gt: 0, oSize: 20 },
        "checkbox-config": { reserve: true },
        "row-config": { keyField: 'tradeOrderDetailId' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_column, {
            field: "left",
            title: "Name",
            width: "50",
            align: "center"
          }, {
            header: _withCtx(() => [
              _createVNode(_component_a_checkbox, {
                onChange: changeAllCheckedStatus,
                checked: checkAllStatus.value,
                "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((checkAllStatus).value = $event)),
                indeterminate: _unref(indeterminateStatus)
              }, null, 8, ["checked", "indeterminate"])
            ]),
            default: _withCtx(({ rowIndex }) => [
              _createVNode(_component_a_checkbox, {
                onChange: changeItemCheckedStatus,
                checked: currentItemCheckedStatusArr.value[rowIndex],
                "onUpdate:checked": ($event: any) => ((currentItemCheckedStatusArr.value[rowIndex]) = $event)
              }, null, 8, ["checked", "onUpdate:checked"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_column, {
            field: "tradeOrderDetailId",
            title: "订单明细ID",
            "min-width": "120"
          }),
          _createVNode(_component_vxe_column, {
            field: "outCode",
            title: "ERP商品编码",
            "min-width": "120"
          }),
          _createVNode(_component_vxe_column, {
            field: "itemName",
            title: "商品名称",
            "min-width": "250"
          }),
          _createVNode(_component_vxe_column, {
            field: "itemCode",
            title: "商品编码",
            "min-width": "170"
          }),
          _createVNode(_component_vxe_column, {
            field: "itemNum",
            title: "下单数量",
            "min-width": "120"
          }),
          _createVNode(_component_vxe_column, {
            field: "closedNum",
            title: "已取消数量",
            "min-width": "120"
          }),
          _createVNode(_component_vxe_column, {
            field: "tmsOrderNum",
            title: "已发货数量",
            "min-width": "120"
          }),
          _createVNode(_component_vxe_column, {
            field: "deliveredNum",
            title: "已出库数量",
            "min-width": "120"
          }),
          _createVNode(_component_vxe_column, {
            field: "undeliveredNum",
            title: "待发货数量",
            "min-width": "120"
          }),
          _createVNode(_component_vxe_column, {
            field: "applyCloseNum",
            title: "申请取消数量",
            "min-width": "150",
            "edit-render": { autofocus: 'input', placeholder: '请点击输入' }
          }, {
            edit: _withCtx((scope) => [
              _createVNode(_component_a_input_number, {
                class: "oio-input-number",
                value: scope.row.applyCloseNum,
                "onUpdate:value": ($event: any) => ((scope.row.applyCloseNum) = $event),
                min: 0,
                controls: false
              }, null, 8, ["value", "onUpdate:value"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_column, {
            field: "characteristics",
            title: "产品特性",
            "min-width": "150"
          }),
          _createVNode(_component_vxe_column, {
            title: "换算关系",
            width: "150"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", null, _toDisplayString(_unref(generateConvertRelationStr)(row.itemSpecifications)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_column, {
            title: "取消原因",
            "min-width": "250"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_a_select, {
                  class: "oio-select",
                  value: scope.row.deliAriesSellerOrderCancelReason?.id,
                  options: 
                  __props._data.cancelReasonList.map((item) => ({
                    label: item.cancelReason,
                    value: item.id
                  }))
                ,
                  getPopupContainer: getPopupContainer,
                  allowClear: "",
                  onChange: (id) => handleReasonChange(scope, id)
                }, null, 8, ["value", "options", "onChange"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createElementVNode("div", _hoisted_10, "已选 " + _toDisplayString(_unref(checkedTotal)) + " 条", 1),
    _createVNode(_unref(OioModal), {
      visible: editModalVisible.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((editModalVisible).value = $event)),
      title: "批量修改",
      width: "medium",
      "get-trigger-container": getModalContainer
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(OioButton), {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (editModalVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_unref(OioButton), {
          type: "primary",
          onClick: onSubmitBatchEdit
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editModalDataList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "edit-row",
            key: item.id
          }, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_a_select, {
                class: "oio-select",
                "dropdown-class-name": "oio-select-dropdown",
                value: item.type,
                "onUpdate:value": ($event: any) => ((item.type) = $event),
                placeholder: "请选择",
                style: {"width":"100%"},
                "default-active-first-option": false,
                options: _unref(displayEditTypeOptions),
                getPopupContainer: getPopupContainer
              }, null, 8, ["value", "onUpdate:value", "options"])
            ]),
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              (['applyCloseNum'].includes(item.type!))
                ? (_openBlock(), _createBlock(_component_a_input_number, {
                    key: 0,
                    class: "oio-input-number",
                    value: item.value,
                    "onUpdate:value": ($event: any) => ((item.value) = $event),
                    min: 0,
                    style: {"width":"100%"},
                    controls: false
                  }, null, 8, ["value", "onUpdate:value"]))
                : _createCommentVNode("", true),
              (['deliAriesSellerOrderCancelReason'].includes(item.type!))
                ? (_openBlock(), _createBlock(_component_a_select, {
                    key: 1,
                    class: "oio-select",
                    value: item.value,
                    "onUpdate:value": ($event: any) => ((item.value) = $event),
                    options: 
              __props._data.cancelReasonList.map((item) => ({
                label: item.cancelReason,
                value: item.id
              }))
            ,
                    getPopupContainer: getPopupContainer,
                    allowClear: ""
                  }, null, 8, ["value", "onUpdate:value", "options"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createVNode(_unref(MinusCircleOutlined), {
                onClick: ($event: any) => (removeEditModalRow(item.id))
              }, null, 8, ["onClick"]), [
                [_vShow, editModalDataList.value.length > 1]
              ]),
              _withDirectives(_createVNode(_unref(PlusCircleOutlined), { onClick: addEditModalRow }, null, 512), [
                [_vShow, index === editModalDataList.value.length - 1 && index !== _unref(displayEditTypeOptions).length - 1]
              ])
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(OioModal), {
      visible: customerDemandCancelVisible.value,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((customerDemandCancelVisible).value = $event)),
      title: "客需取消提醒",
      width: "small",
      "get-trigger-container": getModalContainer
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(OioButton), {
          type: "primary",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (customerDemandCancelVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(OioForm), {
          ref_key: "customerDemandCancelFormRef",
          ref: customerDemandCancelFormRef
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(OioRow), { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_unref(OioCol), { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: "调拨单号" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioInput), {
                          value: __props.formData.transferOrder,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((__props.formData.transferOrder) = $event)),
                          disabled: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(OioCol), { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: "备货操作人" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioInput), {
                          value: __props.formData.planWriter,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((__props.formData.planWriter) = $event)),
                          disabled: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(OioRow), null, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 512))
}
}

})